export const STATUS_FILTERS_OPTIONS = [
  {
    value: true,
    label: 'Published',
  },
  {
    value: false,
    label: 'Draft',
  },
];
